export default __webpack_public_path__ + "static/media/td-logo.3fa0d737.svg";